import { TaskmapHistoryEntry } from "../../../../API/taskmapConfigHistory";

export type RateZone = { lower: number; upper: number; rate: number };

export function formatBlossomRange(entry: TaskmapHistoryEntry): string {
  const params = entry.generation_parameters.parameters;
  const low = params.cutoff_low;
  const high = params.cutoff_high;
  if (low !== undefined && high !== undefined) {
    return `${low} - ${high}`;
  }
  return "N/A";
}

export function getActiveZones(entry: TaskmapHistoryEntry): RateZone[] {
  const zones = entry.generation_parameters.parameters.zones;
  if (!Array.isArray(zones)) return [];
  return (zones as RateZone[]).filter((zone) => zone.rate > 0);
}
